import React, { useState } from 'react';
import cx from 'classnames';
import { FixedSizeList as List } from 'react-window';
import { Menu, MenuItem } from '@blueprintjs/core';
import { Button, Popover, Icons } from '../';
export const DropdownHeading = ({ badge, items, selectedItem, updateSelection, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const row = ({ index, style }) => {
        const item = items[index];
        const isSelected = selectedItem.key === item.key;
        const { key, label } = item;
        const selectItemOnKeyPress = (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                updateSelection(item);
                setIsOpen(false);
            }
        };
        return (React.createElement("div", { style: style },
            React.createElement(MenuItem, { className: cx('dropdown_item', {
                    'dropdown_item--selected': isSelected,
                    'dropdown_item--empty': key === 'NullValue' || key === '',
                }), key: `dropdown-item-${key}`, text: label, shouldDismissPopover: true, onClick: () => updateSelection(item), onKeyPress: selectItemOnKeyPress, tabIndex: 0 })));
    };
    const createDropdownMenu = () => {
        const itemCount = items.length;
        const listHeight = itemCount < 10 ? itemCount * 40 : 300;
        return (React.createElement(Menu, null,
            React.createElement(List, { height: listHeight, width: 190, itemSize: 40, itemCount: itemCount }, row)));
    };
    const handlePopoverToggle = () => {
        if (!isOpen) {
            setIsOpen(true);
        }
    };
    return (React.createElement("div", { className: "heading-dropdown" },
        React.createElement(Popover, { modifiers: {
                arrow: { enabled: false },
                preventOverflow: { boundariesElement: 'viewport' },
            }, popoverClassName: "dropdown_popover", position: "bottom-left", transitionDuration: 0, isOpen: isOpen, canEscapeKeyClose: false, onInteraction: handlePopoverToggle, onClose: () => setIsOpen(false), autoFocus: false },
            React.createElement(Button, { className: cx('heading-dropdown_title', { 'heading-dropdown_title--open': isOpen }), style: "subtle" },
                React.createElement("h1", { className: "page-header-text" }, selectedItem.label),
                badge,
                React.createElement(Icons, { iconName: "ic-ui-caret-down" })),
            React.createElement("div", { className: "dropdown_content" }, createDropdownMenu()))));
};
//# sourceMappingURL=DropdownHeading.js.map